import React from "react";
import { motion } from "framer-motion";
import { Mountain, TrendingUp, Users, Award } from "lucide-react";
import Program1 from "../../../assets/images/heros/program1.jpg";

const ProgrammeHeroRedesign = () => {
  return (
    <div className="relative min-h-[400px] lg:min-h-[500px] rounded-lg overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url(${Program1})`,
        }}
      />

      {/* Gradient Overlays - Mamba Hikers Theme */}
      <div className="absolute inset-0 bg-gradient-to-br from-mamba-navy/95 via-slate-900/85 to-mamba-navy/90" />
      <div className="absolute inset-0 bg-gradient-to-t from-mamba-navy/95 via-transparent to-transparent" />

      {/* Animated Background Elements - Mamba Hikers Theme */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <motion.div
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.1, 0.15, 0.1],
          }}
          transition={{
            duration: 15,
            repeat: Infinity,
            ease: "easeInOut",
          }}
          className="absolute -top-40 -right-40 w-96 h-96 bg-mamba-sky-blue/20 rounded-full blur-3xl"
        />
        <motion.div
          animate={{
            scale: [1, 1.3, 1],
            opacity: [0.1, 0.15, 0.1],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: "easeInOut",
            delay: 2,
          }}
          className="absolute top-1/3 -left-40 w-96 h-96 bg-mamba-golden/20 rounded-full blur-3xl"
        />
      </div>

      {/* Content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full min-h-[500px] lg:min-h-[600px] px-6 text-center">
        {/* Badge - Mamba Hikers Theme */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="inline-flex items-center gap-2 mb-6 px-4 py-2 bg-mamba-golden/20 backdrop-blur-md border border-mamba-golden/40 rounded-full"
        >
          <TrendingUp className="w-4 h-4 text-mamba-golden" />
          <span className="text-sm text-white font-montserrat font-bold tracking-wide">
            TRAINING PROGRAMS
          </span>
        </motion.div>

        {/* Main Title - Mamba Hikers Theme */}
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-montserrat font-black text-white mb-6 tracking-tight leading-tight max-w-4xl"
        >
          Transform Your
          <span className="block bg-gradient-to-r from-mamba-golden via-mamba-sky-blue to-mamba-sky-blue bg-clip-text text-transparent">
            Hiking Journey
          </span>
        </motion.h1>

        {/* Subtitle - Mamba Hikers Theme */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-lg sm:text-xl md:text-2xl text-slate-200 mb-12 max-w-3xl leading-relaxed font-inter"
        >
          From beginner trails to summit mastery.{" "}
          <span className="font-dancing italic text-mamba-golden">
            Mamba Hikers
          </span>{" "}
          progressive training programs designed to elevate your skills and
          confidence on the mountains.
        </motion.p>

        {/* Stats */}
        {/* <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="grid grid-cols-3 gap-6 sm:gap-12 max-w-3xl w-full"
        >
          {[
            { icon: Mountain, label: "Programs", value: "10+" },
            { icon: Users, label: "Graduates", value: "500+" },
            { icon: Award, label: "Success Rate", value: "95%" },
          ].map((stat, index) => (
            <motion.div
              key={index}
              whileHover={{ y: -5 }}
              className="backdrop-blur-md bg-white/5 rounded-2xl border-2 border-mamba-golden/30 p-6 hover:bg-white/10 transition-all duration-300"
            >
              <stat.icon className="w-8 h-8 text-mamba-golden mx-auto mb-3" />
              <div className="text-3xl font-montserrat font-black bg-gradient-to-r from-mamba-golden to-mamba-sky-blue bg-clip-text text-transparent mb-1">
                {stat.value}
              </div>
              <div className="text-slate-300 text-sm font-medium">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </motion.div> */}

        {/* Scroll Indicator */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 1 }}
          className="absolute bottom-8 left-1/2 transform -translate-x-1/2"
        >
          <motion.div
            animate={{ y: [0, 10, 0] }}
            transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
            className="flex flex-col items-center gap-2"
          >
            <span className="text-xs text-slate-400 uppercase tracking-wider">
              Scroll
            </span>
            <div className="w-6 h-10 rounded-full border-2 border-slate-400 flex justify-center p-2">
              <motion.div
                animate={{ y: [0, 12, 0] }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="w-1 h-2 bg-emerald-400 rounded-full"
              />
            </div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default ProgrammeHeroRedesign;
